import { message } from "antd";
import React from "react";
import { MessageType, ResponseMessage } from "../../../models/common/response-message";
import { CheckedIcon, InfoCircleIcon } from "../icon";


export const showMessage = (value: ResponseMessage) => {
	if (value) {
		switch (value.type) {
			case MessageType.success:
				message.success({ content: value.message, icon: <CheckedIcon /> })
				break;
			case MessageType.warning:
				message.warning(value.message)
				break;
			case MessageType.info:
				message.info(value.message)
				break;
			default:
				message.error({ content: value.message, icon: <InfoCircleIcon /> })
				break;
		}
	}
}
